module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"edit_comment_label":"댓글 수정","delete_comment_label":"댓글 삭제","delete_comment_confirmation":"댓글을 삭제하시겠습니까?"}}')
  delete Component.options._Ctor
}
